"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

var _AutocompleteField = require("../elements/AutocompleteField.vue");

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: { AutocompleteField: _AutocompleteField2.default },

  props: ["placeholder", "icon", "color", "colorPlaceholder", "backgroundColor", "iconColor", "name", "disabled", "type", "initialValue", "required", "debounce", "immediateChange", "autocomplete", "allowInitialValueToChangeTextData", "dataList"],

  data: function data() {
    return {
      text: this.initialValue || "",
      filteredDataList: [],
      isFocused: false
    };
  },


  mixins: [_input2.default],

  computed: {
    inputType: function inputType() {
      return this.type ? this.type : "text";
    },
    classes: function classes() {
      var baseClasses = ["input-wrapper", "clearfix"];

      baseClasses.push(this.inputTextColorClass);

      if (this.backgroundColor) {
        baseClasses.push("has-background-" + this.backgroundColor);
      }
      if (this.colorPlaceholder) {
        baseClasses.push("input-placeholder-color-" + this.colorPlaceholder);
      }
      return baseClasses;
    },
    setIconColor: function setIconColor() {
      return this.inputIconColorClass;
    },


    /**
     * Input has suggestions
     * @returns {boolean}
     */
    hasSuggestions: function hasSuggestions() {
      return (this.filteredDataList || []).length > 0;
    },


    /**
     * Selected option id
     * @returns {*}
     */
    selectedOptionId: function selectedOptionId() {
      var _this = this;

      var selectedOption = (this.dataList || []).find(function (item) {
        return item.name === _this.text;
      });

      return selectedOption ? selectedOption.id : null;
    }
  },

  methods: {
    change: function change() {
      if (this.immediateChange || this.text.length > 2 || this.text.length == 0) {
        if (this.debounce) {
          this.debounceFunction();
        } else {
          this.textChanged();
        }
      }
    },
    changed: function changed(event) {
      this.$emit("change", event.target.value);
    },

    debounceFunction: _.debounce(function () {
      this.textChanged();
    }, 500),

    /**
     * Suggestion is selected
     * @param value
     */
    suggestionSelected: function suggestionSelected(item) {
      this.text = item.name;
      this.filteredDataList = [];
    },


    /**
     * Text is changed
     */
    textChanged: function textChanged() {
      this.emitEvents();
      this.setSuggestionsList();
    },


    /**
     * Emit events after text is changed
     */
    emitEvents: function emitEvents() {
      this.$emit("change", this.text);
      this.$emit("input", this.text);
    },


    /**
     * Set input suggestions list
     */
    setSuggestionsList: function setSuggestionsList() {
      var search = this.text ? this.text.toLowerCase() : null;
      this.filteredDataList = search ? (this.dataList || []).filter(function (item) {
        var itemText = item.name.toLowerCase();

        return itemText !== search && itemText.indexOf(search) >= 0;
      }) : [];
    },


    /**
     * Input is focused
     */
    focused: function focused() {
      this.isFocused = true;
    },


    /**
     * Input is blured
     */
    blured: function blured() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.isFocused = false;
      }, 500);
    },


    /**
     * Input value
     * @param event
     */
    input: function input(event) {
      this.$emit('input', event.target.value);
    }
  },

  watch: {
    initialValue: function initialValue(value) {
      if (this.allowInitialValueToChangeTextData) {
        this.text = value;
      }
    },
    text: function text(value) {
      this.change();
    },
    selectedOptionId: function selectedOptionId(value) {
      this.$emit("option-change", value);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/InputField.vue
// module id = pM32
// module chunks = 0 1